import React from 'react';
import './AboutSection.css';
import mahmutaluc from '../../assets/mahmutaluc.jpeg'
const AboutSection = () => {
  return (
    <section className="about-modern" id="about">
      <div className="about-wrapper">
        
        {/* GÖRSEL ALAN */}
        <div className="about-visual-side">
          <div className="doctor-image-container">
            <div className="image-frame-decoration"></div>
            {/* Müşteri talebi: Ameliyathane yerine daha sıcak görseller */}
            <img 
              src={mahmutaluc} 
              alt="Dr. Mahmut Aluç" 
              className="vertical-doctor-img"
            />
            <div className="experience-badge-mini">
              <span className="exp-num">30+</span>
              <span className="exp-txt">Yıllık Birikim</span>
            </div>
          </div>
        </div>

        {/* METİN ALANI */}
        <div className="about-content-side">
          <div className="title-area">
            <h4 className="mini-title">HAKKIMIZDA</h4>
            <h2 className="main-name-title">
             Op. Dr. <span>Mahmut</span> Aluç
            </h2>
            <h5 className="sub-university">Cumhuriyet Üniversitesi Tıp Fakültesi (1992)</h5>
          </div>

       

          <div className="features-highlight-grid">
            <div className="highlight-item">
              <div className="h-dot"></div>
              <p><strong>Akademik İhtisas:</strong> Çukurova Üniversitesi Çocuk Cerrahisi Ana Bilim Dalı uzmanlığı.</p>
            </div>
            <div className="highlight-item">
              <div className="h-dot"></div>
              <p><strong>Geniş Deneyim:</strong> Sivas SSK, Devlet, Numune ve MEDICANA hastanelerinde uzun yıllar klinik tecrübe.</p>
            </div>
            
          </div>

          <div className="philosophy-footer">
            <p>Modern tıpta doğum öncesinden (fetal dönem) başlayıp 18 yaşına kadar olan tüm cerrahi süreçleri kapsıyoruz.</p>
          </div>

          <div className="about-signature-area">
            <div className="sig-line"></div>
            <span>Çocuk Cerrahisi Uzmanı</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;